<script>
		import {user, view} from "../client.svelte.js";
		import Sidebar from "../elements/Sidebar.svelte";

		const catLabels = {'part': "vorbereitete NSCs",  'priv': "persönlicher Katalog", 'publ': "öffentlicher Katalog",
											 'hero': "spielbare Helden", 'heroes': "Eigene Helden"}
		const catSorting = {heroes: 1, hero: 2, part: 3, priv: 4, publ: 5}
		const affiliations = {friend: ["Freund", 'outline'], neutral: ["Neutral", 'neutral'], enemy: ["Feind", 'accent']}
		const filterFields = {race: "Volk", subgroup: "Untergruppe", vocation: "Beruf / Profession"}

		let search = $state("")
		let filters = $state({race: "", subgroup: "", vocation: ""})

		let chars = $derived(user.characters.values()
			.filter((char) => char.ZUB !== 'Hero')
			.toArray()
			.sort((char1,char2) => char1.name.localeCompare(char2.name)) )
		let options = $derived(Object.fromEntries(Object.keys(filterFields)
			.map(field => [field, [...new Set(chars.map(char => char[field]).filter(Boolean))].sort()])))
		let filtered = $derived(chars.filter(char => {
				const term = search.trim().toLowerCase()
				return (!term || char.name?.toLowerCase().includes(term) || char.CS?.toLowerCase().includes(term)) &&
				       Object.entries(filters).every(([field, value]) => !value || char[field] === value)
		}))
		let isFiltered = $derived(!!search || Object.values(filters).some(Boolean))

		let groups = $derived(
			Object.entries(
				Object.groupBy(filtered, (char) => (char.rubric === view.adventure?.ID) ? 'part' : char.cat))
					.sort(([cat1], [cat2]) => (catSorting[cat1] ?? 9) - (catSorting[cat2] ?? 9))
					.map(([cat, list]) => ({label: catLabels[cat] ?? cat, chars: list})) )

		async function create_character() {
				// const charData = await send_data("/character/_", {}, 'POST')
		}

		async function select_character(charID) {
				await view.select_character(charID)
				view.switch_layout('advt-charDetails')
		}

		function pickup_character(e, char) {
				e.dataTransfer.setData('char/ID', char.ID)
				e.dataTransfer.effectAllowed = 'copy'
		}

</script>


<!-------------------------------- HTML -------------------------------------->

{#snippet filter()}
	<div class="field">
		<label for="charSearch">Suche</label>
		<input id="charSearch" placeholder="Name oder Rufzeichen" bind:value={search}>
	</div>
	{#each Object.entries(filterFields) as [field, label]}
		<div class="field">
			<label for="filter-{field}" data-help="filter">{label}</label>
			<select id="filter-{field}" data-help="filter" bind:value={filters[field]}>
				<option value="">alle</option>
				{#each options[field] as option}<option value={option}>{option}</option>{/each}
			</select>
		</div>
	{/each}
{/snippet}

<section id={view.layout.page}>
	<Sidebar flyout={filter} items={[
		{id: 'create', icon: 'plus', label: "Neuer NSC", title: "Neuen NSC erstellen", primary: true, onclick: create_character},
		{id: 'filter', icon: 'filter', label: "Filtern", flyout: "Charaktere filtern", active: isFiltered} ]}/>

	<article class="page">
		{#each groups as group (group.label)}
			<div class="group">
				<h3>{group.label} <span class="tag neutral">{group.chars.length}</span></h3>
				<div class="tileGrid" style:--tile-min="260px">
					{#each group.chars as char (char.ID)}
						{@const affil = affiliations[char.affiliation]}
						<button class="card tile row" title={char.ID} draggable=true ondragstart={(e) => pickup_character(e, char)}
						        onclick={() => select_character(char.ID)}>
							<img class="token" src={char.tokenURL} alt={char.CS ?? char.ID}>
							<span class="charText">
								<span class="ellipsis">{char.name}</span>
								<span class="card-meta">{[char.vocation ?? char.race, (char.level != null) ? `Stufe ${char.level}` : null].filter(Boolean).join(" · ")}</span>
							</span>
							{#if affil}<span class="tag {affil[1]}">{affil[0]}</span>{/if}
						</button>
					{/each}
				</div>
			</div>
		{:else}
			<p class="empty">Keine Charaktere gefunden.</p>
		{/each}
	</article>
</section>


<style lang="sass">
	.charText
		flex: 1
		display: flex
		flex-direction: column
		gap: 3px
		min-width: 0
		font-size: 16px
</style>
